import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-select-dropdown',
    templateUrl: './select-dropdown.component.html',
    styleUrls: ['./select-dropdown.component.css']
})
export class SelectDropdownComponent implements OnInit {
    @Input() selectList: any[];
    @Input() selectedValue;
    @Output() onSelectValueChange = new EventEmitter<any>();

    constructor() {}

    ngOnInit(): void {}

    onSelectionChange(e) {
        this.onSelectValueChange.emit(e.value);
    }
}
